import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {catchError, debounceTime, distinctUntilChanged, map, tap, switchMap} from 'rxjs/operators';
import { environment } from './../../../../src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ShippingGlossaryService {

  constructor(private http:HttpClient) { }

  API_KEY = environment.API_KEY;
  URL_1 = environment.Shipping_glossary_URL_1;
  URL_2 = environment.Shipping_glossary_URL_2;
   
  searchShippingGlossary(term: string) {
    if (term === '') {
      return of([]);
    }
    return this.http
      .get(this.URL_1,  { params: {
        action: 'names',
        term:term
      }}).pipe(
        map((response :any) =>  response['data'])
      );
  }

  getShoppingDetailsByName(value:any){
    return this.http
        .get(this.URL_2,  { params: {
          type: 'searchByName',
          value:value
        }}).pipe(
          map((response:any) => response ?  response['data'] :[])
        );
    }

    getShoppingDetailsByNameAll(){
      return this.http
      .get(this.URL_2,  { params: {
        type: 'showAll',
        value:'all'
      }}).pipe(
        map((response :any) => response ?  response['data'] : [])
      );
    }
   
}



